import { ref as ct, computed as ut, customRef as at, shallowReactive as ft, onMounted as vt, watch as y, isRef as dt, isReactive as mt, onBeforeUnmount as pt, readonly as wt, unref as _ } from "vue";
const p = typeof window > "u", j = 10;
function nt(r) {
  Reflect.defineProperty(r, "v", { get: () => r.value, set(a) {
    r.value = a;
  } });
}
function tt(r) {
  const a = ct(r);
  return nt(a), a;
}
function H(r) {
  const a = ut(r);
  return Reflect.defineProperty(a, "v", { get: () => a.value }), a;
}
function et(r, a) {
  const E = at((d, m) => {
    let T = a;
    return { get: () => (d(), T), set(R) {
      T = r.value ? R : a, m();
    } };
  });
  return nt(E), E;
}
const f = { jumpToFirst: !0, jumpToLast: !0, overlayHeight: 0, minWidth: 0, replaceHash: !1, root: null, boundaryOffset: { toTop: 0, toBottom: 0 }, edgeOffset: { first: 100, last: -100 } };
function gt(r, a = f) {
  const { root: E = f.root, jumpToFirst: d = f.jumpToFirst, jumpToLast: m = f.jumpToLast, overlayHeight: T = f.overlayHeight, minWidth: R = f.minWidth, replaceHash: ot = f.replaceHash, boundaryOffset: { toTop: it = f.boundaryOffset.toTop, toBottom: st = f.boundaryOffset.toTop } = f.boundaryOffset, edgeOffset: { first: z = f.edgeOffset.first, last: $ = f.edgeOffset.last } = f.edgeOffset } = a, v = H(() => p ? null : _(E) instanceof HTMLElement ? _(E) : document.documentElement), b = H(() => v.v === document.documentElement), i = ft({ els: [], top: /* @__PURE__ */ new Map(), bottom: /* @__PURE__ */ new Map() }), w = tt(p || window.matchMedia(`(min-width: ${R}px)`).matches), h = et(w, !1), x = tt(!1), rt = H(() => h.v ? L() : 0), s = et(w, null), F = H(() => {
    var t;
    return ((t = s.v) == null ? void 0 : t.id) || "";
  }), q = H(() => i.els.indexOf(s.v));
  let O, Y = p ? 0 : L(), I = !0;
  function L() {
    return b.v ? window.scrollY : v.v.scrollTop;
  }
  function P() {
    return b.v ? v.v.getBoundingClientRect().top : -v.v.scrollTop;
  }
  function A() {
    if (p) return;
    let t = [];
    r.value[0] instanceof HTMLElement ? t = r.value : r.value.forEach((n) => {
      const o = document.getElementById(n);
      o && t.push(o);
    }), t.sort((n, o) => n.getBoundingClientRect().top - o.getBoundingClientRect().top), i.els = t;
    const e = v.v.getBoundingClientRect().top - (b.v ? 0 : v.v.scrollTop);
    i.top.clear(), i.bottom.clear(), t.forEach((n) => {
      const { top: o, bottom: c } = n.getBoundingClientRect(), l = n.id || Math.random().toString(36).substr(2, 9);
      i.top.set(l, o - e), i.bottom.set(l, c - e);
    });
  }
  function W({ prevY: t, isScrollCancel: e = !1 }) {
    const n = L();
    return n < t ? function() {
      let o = m ? B(i.els) : null;
      const c = P(), l = j + T + it;
      if (Array.from(i.bottom).some(([u, g], Z) => {
        const lt = m || Z !== i.bottom.size - 1 ? 0 : $;
        if (c + g > l + lt) return o = i.els[Z], !0;
      }), !d && o === i.els[0]) {
        const u = i.top.values().next().value;
        if (u && c + u > l + z) return s.v = null;
      }
      (i.els.indexOf(o) < i.els.indexOf(s.v) || o && !s.v) && (s.v = o);
    }() : M({ isScrollCancel: e }), n;
  }
  const B = (t) => t[t.length - 1];
  function C() {
    if (!d && !m) return !1;
    const { isBottom: t, isTop: e } = function(n) {
      const o = n === document.documentElement ? window.innerHeight : n.clientHeight;
      return { isTop: n.scrollTop <= 2 * j, isBottom: Math.abs(n.scrollHeight - o - n.scrollTop) <= 1 };
    }(v.v);
    return d && e ? (s.v = i.els[0], !0) : m && t ? (s.v = B(i.els), !0) : void 0;
  }
  function M({ isScrollCancel: t } = { isScrollCancel: !1 }) {
    let e = d ? i.els[0] : null;
    const n = P(), o = j + T + st;
    if (Array.from(i.top).some(([c, l], u) => !(n + l < o + (d || u !== 0 ? 0 : z)) || (e = i.els[u], !1)), !m && e === B(i.els)) {
      const c = B(Array.from(i.bottom.values()));
      if (n + c < o + $) return s.v = null;
    }
    if (i.els.indexOf(e) > i.els.indexOf(s.v) || e && !s.v) return s.v = e;
    t && (s.v = e);
  }
  function k() {
    h.v || (Y = W({ prevY: Y }), C());
  }
  function N(t = 20) {
    let e, n = L(), o = 0;
    e = window.requestAnimationFrame(function c() {
      o++;
      const l = L();
      if (n !== l) return o = 0, n = l, window.requestAnimationFrame(c);
      o === t ? (x.v = !0, h.v = !1, cancelAnimationFrame(e)) : window.requestAnimationFrame(c);
    });
  }
  function U() {
    const t = i.els.find(({ id: e }) => e === location.hash.slice(1));
    if (t) return s.v = t, !0;
  }
  function X(t) {
    var e;
    if (!((e = t == null ? void 0 : t.state) != null && e.current.includes("#")) && s.v) return s.v = d ? i.els[0] : null;
    U();
  }
  function D() {
    window.addEventListener("popstate", X);
  }
  function G() {
    window.removeEventListener("popstate", X);
  }
  function J() {
    w.v = window.matchMedia(`(min-width: ${R}px)`).matches;
  }
  function K() {
    O = new ResizeObserver(() => {
      I ? I = !1 : (A(), window.requestAnimationFrame(() => {
        C() || M();
      }));
    }), O.observe(v.v);
  }
  function Q() {
    O == null || O.disconnect();
  }
  function S() {
    h.v = !1;
  }
  vt(async () => {
    window.addEventListener("resize", J, { passive: !0 }), await new Promise((t) => window.setTimeout(t)), w.v && (A(), K(), location.hash ? N(10) : x.v = !0, D(), U() || C() || M());
  }), y(v, A, { flush: "post" }), y(dt(r) || mt(r) ? r : () => null, A, { flush: "post" }), y(w, (t) => {
    t ? (A(), K(), D(), C() || M()) : (s.v = null, G(), Q());
  }), y(q, (t) => {
    if (ot) {
      const e = location.href.split("#")[0], n = t > (d ? 0 : -1) ? `#${F.v}` : "";
      history.replaceState(history.state, "", `${e}${n}`);
    }
  }), pt(() => {
    window.removeEventListener("resize", J), G(), Q();
  }), y([x, w, v, r], ([t, e, n, o], c, l) => {
    if (p) return;
    const u = b.v ? document : n, g = u && t && e && o.length > 0;
    g && u.addEventListener("scroll", k, { passive: !0 }), l(() => {
      g && u.removeEventListener("scroll", k);
    });
  });
  const V = [["wheel", S, { once: !0 }], ["touchmove", S, { once: !0 }], ["keydown", function(t) {
    t.code === "Space" && S();
  }, { once: !0 }], ["scroll", N, { passive: !0, once: !0 }], ["pointerdown", function(t) {
    if (t.target.tagName !== "A") {
      const e = window.CSS.supports("-moz-appearance", "none"), n = function(o, c) {
        const l = c === document.documentElement ? window.innerWidth : c.clientWidth;
        return o.clientX >= l - 17;
      }(t, v.v);
      (e || n) && (S(), W({ prevY: rt.v, isScrollCancel: !0 }));
    }
  }]];
  return y(h, (t, e, n) => {
    const o = b.v ? document : v.v, c = r.value.length > 0;
    t && c && V.forEach(([l, u, g]) => o.addEventListener(l, u, g)), n(() => {
      t && c && V.forEach(([l, u]) => o.removeEventListener(l, u));
    });
  }), { isActive: function(t) {
    return !p && (typeof t == "string" ? t === F.v : t instanceof HTMLElement && t === s.v);
  }, setActive: function(t) {
    if (p) return;
    let e = null;
    typeof t == "string" ? e = i.els.find(({ id: n }) => n === t) || null : t instanceof HTMLElement && (e = i.els.find((n) => n === t) || null), e && (s.v = e, h.v = !0);
  }, activeEl: wt(s), activeId: F, activeIndex: q };
}
export {
  gt as useActive,
  gt as useActiveScroll
};
